import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { RiMenu4Fill } from 'react-icons/ri';
import { ChevronDown } from 'lucide-react';
import { useIsMobile } from   '@/hooks/use-mobile';

interface DropdownTriggerProps {
  avatarUrl: string | null;
  username: string | null;
  email: string | null;
  getInitials: () => string;
}

const DropdownTrigger = ({ avatarUrl, username, email, getInitials }: DropdownTriggerProps) => {
  const isMobile = useIsMobile();
  
  return (
    <button 
      className="flex items-center space-x-2.5 p-1 hover:bg-gray-50 rounded-md transition-colors focus:outline-none" 
      type="button"
    >
      <Avatar className={`${isMobile ? 'h-8 w-8' : 'h-9 w-9'} border border-gray-200 bg-gray-50`}>
        {avatarUrl && (
          <AvatarImage 
            src={avatarUrl} 
            alt={username || email || 'User'} 
            onError={(e) => {
              console.warn('Avatar image failed to load:', avatarUrl);
            }}
          />
        )}
        <AvatarFallback className="bg-primary/10 text-primary text-sm">
          {getInitials()}
        </AvatarFallback>
      </Avatar>
      {isMobile ? (
        <RiMenu4Fill className="h-4.5 w-4.5 text-gray-500" />
      ) : (
        <ChevronDown className="h-4 w-4 text-gray-500" />
      )}
    </button>
  );
};

export default DropdownTrigger;
